// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__yxea2","truncatedText":"styles_truncatedText__ui0Lf","fullText":"styles_fullText__92m0S","textContainer":"styles_textContainer__siHMn"};